import { formatDate } from "../../../../helpers/date";

import ProjectProgress from "../../../project/ProjectListPage/components/ProjectProgress";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});

export default [
  {
    Header: "Hours",
    headerClassName: "flex -center-h",
    accessor: "hoursConsumed",
    id: "hours_consumed",
    maxWidth: 100,
    minWidth: 100,
    Cell: ProjectProgress
  },
  {
    Header: "Project",
    accessor: "name",
    id: "name"
  },
  {
    Header: "Customer",
    accessor: "customer.name",
    id: "customer.name"
  },
  {
    Header: "Category",
    accessor: "category.label",
    id: "category.label",
    maxWidth: 120
  },
  {
    Header: "Department Category",
    accessor: "department_category.name",
    id: "department_category.name",
    maxWidth: 120
  },
  {
    Header: "Start Date",
    accessor: "start_date",
    id: "start_date",
    maxWidth: 120,
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "End Date",
    accessor: "end_date",
    id: "end_date",
    maxWidth: 120,
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "Expected End Date",
    accessor: "expected_end_date",
    id: "expected_end_date",
    maxWidth: 140,
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "Budget Amount",
    id: "budget_amount",
    accessor: "budget_amount",
    maxWidth: 120,
    Cell: ({ value }) => {
      if (value) {
        return formatter.format(value);
      }
      return "$0.00";
    }
  },
  {
    Header: "Budget Hours",
    id: "budget_hours",
    accessor: "budget_hours",
    maxWidth: 120,
    Cell: ({ value }) => `${value}`
  },
  {
    Header: "Billable",
    id: "billable_hours",
    accessor: "billableHours",
    maxWidth: 100,
    Cell: ({ value }) => `${value}`
  },
  {
    Header: "Actual",
    id: "actual_hours",
    accessor: "actualHours",
    maxWidth: 100,
    Cell: ({ value }) => `${value}`
  }
];
